import { type SingleTripTravelDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/stt';
import { type OPCRowInformation } from '../../../../config/flavourConfig';

const getSingleTripTravelAdjustDetailsConfig = (stt: SingleTripTravelDTO): OPCRowInformation[] => {
    return [];
};

export default getSingleTripTravelAdjustDetailsConfig;
